import { actionTypes } from '../common/constants/actionTypes';

import EventItemDto from '../api/eventItemDto';
import EventItem from '../api/eventItemEntity';
import NewsCategory from '../api/newsCategoryEntity';
import NewsItemDto from '../api/newsItemDto';
import NewsItem from '../api/newsItemEntity';
import TopicListItemsDto from '../api/topicListItemsDto';

export interface IEventsAndNewsState {
  eventCategories: NewsCategory[];
  eventItemDto: EventItemDto;
  latestSelectedEventItem: EventItem;
  latestSelectedNewsItem: NewsItem;
  newsCategories: NewsCategory[];
  newsItemDto: NewsItemDto;
  topicListItemsDto: TopicListItemsDto;
}

const initialState: IEventsAndNewsState = {
  eventCategories: [],
  eventItemDto: new EventItemDto(),
  latestSelectedEventItem: new EventItem(),
  latestSelectedNewsItem: new NewsItem(),
  newsCategories: [],
  newsItemDto: new NewsItemDto(),
  topicListItemsDto: new TopicListItemsDto(),
};

export const eventsAndNewsItemsReducer = (
  state: IEventsAndNewsState = initialState,
  action: any
): IEventsAndNewsState => {
  switch (action.type) {
    case actionTypes.FETCH_NEWS_ITEM_BY_ID_COMPLETED:
      return {
        ...state,
        latestSelectedNewsItem: action.payload as NewsItem,
      };

    case actionTypes.FETCH_EVENT_ITEM_BY_ID_COMPLETED:
      return {
        ...state,
        latestSelectedEventItem: action.payload as EventItem,
      };

    // Note: your action names say FETCH_* (sounds like "request"),
    // but you’re passing payloads. If these are actually "success",
    // consider renaming to *_COMPLETED for clarity.
    case actionTypes.FETCH_NEWS_ITEMS:
      return {
        ...state,
        newsItemDto: action.payload as NewsItemDto,
      };

    case actionTypes.FETCH_EVENT_ITEMS:
      return {
        ...state,
        eventItemDto: action.payload as EventItemDto,
      };

    case actionTypes.FETCH_NEWS_CATEGORIES_COMPLETED:
      return {
        ...state,
        newsCategories: (action.payload as NewsCategory[]) || [],
      };

    case actionTypes.FETCH_EVENT_CATEGORIES_COMPLETED:
      return {
        ...state,
        eventCategories: (action.payload as NewsCategory[]) || [],
      };

    case actionTypes.FETCH_TOPIC_ITEMS:
      return {
        ...state,
        topicListItemsDto: action.payload as TopicListItemsDto,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/eventsAndNewsItems.ts